<template>
  <GeneralSalesScreen :outsideTypeSale="outsideTypeSale" />
</template>

<script>
import GeneralSalesScreen from "./GeneralSalesScreen.vue";
export default {
  props: {
    outsideTypeSale: {
      type: String,
      default: "Receita Pedido",
    },
  },
  components: {
    GeneralSalesScreen,
  },
};
</script>